module.exports = __webpack_public_path__ + "img/file.a6a12e09.svg";